import { isEventbriteTLD } from '../selectors/app';
import { isLoginInterstitialSplitTreatmentEnabled } from '../selectors/splitio';
import { CheckoutState } from '../state';
import { isEventbriteTLDInDevOrQAEnv } from '../utils/browser';

export const isStatsigFreeTrialEnabledForInterstitialLogin = (
    state: CheckoutState,
): boolean =>
    (isEventbriteTLD(state) || isEventbriteTLDInDevOrQAEnv()) &&
    isLoginInterstitialSplitTreatmentEnabled(state);

export const isStatsigFreeTrialEnabled = (state: CheckoutState) =>
    isStatsigFreeTrialEnabledForInterstitialLogin(state);
